export default __webpack_public_path__ + "static/face_3-9dc2cfd2e7ff037b5e87bd01b90f2e29.jpg";